import * as React from 'react';

import { cn } from '@rematter/ui-web';

type PhotoGridProps = React.PropsWithChildren & { className?: string };

// 267px PHOTO_CARD_DEFAULT_WIDTH
export const PhotoGrid: React.FC<PhotoGridProps> = ({
  className,
  children,
}) => (
  <div
    className={cn(
      '@PhotoGrid',
      'grid grid-cols-[repeat(auto-fill,267px)] gap-4',
      className,
    )}
  >
    {children}
  </div>
);
